import { Action, createReducer, on } from '@ngrx/store';
import IUserGroupsState, {
  groupsAdapter,
  userGroupsInitialState,
} from './user-groups.state';
import { UserGroupsActions } from './user-groups.actions';

const reducer = createReducer(
  userGroupsInitialState,
  on(
    UserGroupsActions.loadUserGroups,
    (state: IUserGroupsState): IUserGroupsState => ({
      ...state,
      groupsLoaded: false,
    }),
  ),
  on(
    UserGroupsActions.loadUserGroupsSuccess,
    (state: IUserGroupsState, { groups }): IUserGroupsState => ({
      ...state,
      groups: groupsAdapter.setAll(groups, { ...state.groups }),
      groupsLoaded: true,
    }),
  ),
  on(
    UserGroupsActions.loadUserGroupsError,
    (state: IUserGroupsState, { error }): IUserGroupsState => ({
      ...state,
      groupsLoaded: false,
      loadingGroupsError: error,
    }),
  ),
);

export const UserGroupsReducer = (
  state: IUserGroupsState | undefined,
  action: Action,
) => reducer(state, action);
